import React from "react";
import { useApp } from "context";
import { Qiosk } from "components";
import { LogoBrand, LogoBrandDark } from "assets/images";
import { Constants, Enums, Helpers, Methods } from "utils";
import { IAppointment } from "interfaces";
import { useInactivityReset } from "hooks";

type Props = {};

// TODO: the whole logic of qiosk is messed up and needs to be rewritten
export const CheckIn = (props: Props) => {
  const { t, theme, user, service } = useApp();

  const [step, setStep] = React.useState<number>(Enums.EnumCheckInStep.Email);
  const [email, setEmail] = React.useState<string>("");
  const [patientId, setPatientId] = React.useState<number | null>(null);
  const [appointments, setAppointments] = React.useState<IAppointment[]>([]);

  // TODO: is key property the only way for full reset in function components?
  const [key, setKey] = React.useState(0);

  const resetQiosk = () => {
    handleStep(Enums.EnumCheckInStep.Email, "", null, []);
    setKey((prevKey) => prevKey + 1);
  };

  useInactivityReset(resetQiosk, Constants.REFRESH_RATE.QIOSK);

  const handleStep = (
    step: number,
    email?: string | null,
    patientId?: number | null,
    appointments?: IAppointment[]
  ) => {
    if (email === Constants.QIOSK_PASSCODE) {
      Helpers.toggleFullScreen();
      resetQiosk();
      return;
    }

    if (step === Enums.EnumCheckInStep.WalkInNotAllowed) {
      resetQiosk();
      return;
    }

    setStep(step);
    Helpers.hasValue(email) && setEmail(email ?? "");
    setPatientId(patientId ?? null);
    appointments && appointments.length > 0 && setAppointments(appointments);

    if (step === Enums.EnumCheckInStep.MakeAppointment) {
      Methods.makeAppointment(
        service,
        user.userId,
        Constants.PROVIDER_ID,
        patientId ?? null,
        Constants.CALENDAR_ID,
        Constants.SERVICE_ID,
        Helpers.clearTime(new Date()),
        Helpers.toTimeAmPmString(Helpers.toSeconds(new Date()), false),
        null,
        [],
        true,
        true
      );
      resetQiosk();
    }
  };

  return (
    <div className="qh-page">
      <div className="qh-wrapper ">
        <div className="qh-header">
          <div className="qh-title">
            <small>
              {Helpers.interpolate(t.message.greeting.welcome_to, {
                username: "",
              })}
            </small>
            {user.username}
          </div>
          {theme.id === Enums.EnumTheme.Light ? (
            <LogoBrandDark />
          ) : (
            <LogoBrand />
          )}
        </div>
        <div className="qh-content" key={key}>
          {[
            Enums.EnumCheckInStep.Home,
            Enums.EnumCheckInStep.MakeAppointment,
          ].includes(step) ? (
            <Qiosk.Email onClick={handleStep} />
          ) : step === Enums.EnumCheckInStep.Scan ? (
            <Qiosk.Scan onClick={handleStep} />
          ) : step === Enums.EnumCheckInStep.Email ? (
            <Qiosk.Email onClick={handleStep} />
          ) : step === Enums.EnumCheckInStep.Register ? (
            <Qiosk.Register onClick={handleStep} email={email} />
          ) : step === Enums.EnumCheckInStep.Appointment ? (
            <Qiosk.Appointment
              patientId={patientId}
              appointments={appointments}
              onClick={handleStep}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};
